module.exports = __webpack_public_path__ + "static/media/pagoPa-form.80ef772e.svg";